const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIndividualMobileNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16403_8052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 12.75C11.7465 12.75 14.1487 13.9312 15.4552 15.6937L14.0737 16.347C13.0102 15.087 11.1352 14.25 8.99997 14.25C6.86472 14.25 4.98972 15.087 3.92622 16.347L2.54547 15.693C3.85197 13.9305 6.25347 12.75 8.99997 12.75ZM8.99997 1.5C9.99453 1.5 10.9484 1.89509 11.6516 2.59835C12.3549 3.30161 12.75 4.25544 12.75 5.25V7.5C12.7499 8.46635 12.3768 9.39537 11.7085 10.0933C11.0401 10.7913 10.1282 11.2043 9.16272 11.2463L8.99997 11.25C8.00541 11.25 7.05158 10.8549 6.34832 10.1517C5.64506 9.44839 5.24997 8.49456 5.24997 7.5V5.25C5.25003 4.28365 5.62313 3.35463 6.29147 2.65667C6.9598 1.95871 7.87178 1.54569 8.83722 1.50375L8.99997 1.5ZM8.99997 3C8.42606 2.99997 7.87384 3.21924 7.45628 3.61296C7.03872 4.00668 6.78739 4.54508 6.75372 5.118L6.74997 5.25V7.5C6.74941 8.08568 6.97724 8.6485 7.38505 9.06886C7.79286 9.48923 8.34852 9.73401 8.93394 9.7512C9.51937 9.76839 10.0884 9.55662 10.5202 9.1609C10.952 8.76519 11.2124 8.2167 11.2462 7.632L11.25 7.5V5.25C11.25 4.65326 11.0129 4.08097 10.591 3.65901C10.169 3.23705 9.59671 3 8.99997 3Z",
    fill: "#080917",
    style: {
      fill: "#080917",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16403_8052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#080917",
    style: {
      fill: "#080917",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIndividualMobileNav);
export default __webpack_public_path__ + "static/media/customer-individual-mobile-nav.67508bf8e2d868e284e3203b07746e73.svg";
export { ForwardRef as ReactComponent };